<template>
<div class='myPostIndexnew'>
            <div class="paginationBox" v-if="!setitem">
            <el-pagination :page-size.sync="postPageSize" :pager-count="11" :current-page.sync="postPageNum" layout="prev, pager, next" :total="postPageTotle" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    <div class='cont' v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)">
        <div class="selectCont">

    <div>
        <el-input placeholder="请输入内容" v-model="jobname" class="jobname">
            <el-button slot="append" icon="el-icon-search"  @click="cxjblistv()"></el-button>
        </el-input>
    </div>

                <el-radio-group v-model="postStatus" @change="changePostStatus">
                <el-radio-button label="1">上线职位({{ postPageTotle1 }})</el-radio-button>
                <el-radio-button label="2">下线职位({{ postPageTotle2 }})</el-radio-button>
            </el-radio-group>
        </div>
        <div class="tableCont">
            <div class="zwinfobox" v-if="setitem">
            <div class="topbtnbox">
                <el-page-header @back="closetsc" content="职位详情"></el-page-header>
                <!-- <div class="delbtn" @click="closetsc()"><i class="el-icon-arrow-left" ></i>返回</div> -->
            </div>
            <div class="qyname">{{ setitem.customCompanyEVo.customCompanyFullName}}</div>
            <div class="zwname">{{ setitem.positionName}}  <el-tag v-for="(item,index) in (setitem.label.split(':'))" :key="index" :type="tagstyle[index]">{{item}}</el-tag></div>            
            <div class="jcinfo">
                <span><i class="el-icon-money" ></i>{{ setitem.minYearSalary + '~' + setitem.maxYearSalary + 'w' }}</span>
                <span><i class="el-icon-map-location" ></i>{{ setitem.workPlace + ',' + setitem.cityName }}</span>
                <span><i class="el-icon-s-opportunity" ></i>{{ setitem.minEducation }}</span>
                <span><i class="el-icon-alarm-clock" ></i>{{ setitem.workingLifeMin + '~' + setitem.workingLifeMax + '年' }}</span>
                <span><i class="el-icon-user" ></i>{{ setitem.recruitsNumber + '人' }}</span>
                <span><i class="el-icon-suitcase" ></i>{{ setitem.industry }}</span>

            </div>
            <div class="jcinfo1">
                <div><span>佣金:</span>{{ Number(setitem.minYearSalary * 0.2).toFixed(2) + '~' + Number(setitem.maxYearSalary * 0.2).toFixed(2) + 'w' }}</div>
                <div><span>分成:</span>{{ setitem.commissionRate }}%</div>
                <div><span>保证期:</span>{{ setitem.warranty }}</div>
                <div><span>付款细则:</span>{{ setitem.payRules }}</div>
                <div><span>更新日期:</span>{{ moment(setitem.updateTime).format('YYYY-MM-DD') }}</div>
            </div>
            <div class="bt">岗位职责</div>
            <div class="infot">{{ setitem.postDuties }}</div>
            <div class="bt">任职要求</div>
            <div class="infot">{{ setitem.postReQuirements }}</div>
            <div class="bt">特殊备注</div>
            <div class="infot">{{ setitem.des }}</div>
            <div class="bt">补充信息</div>
            <div class="infot1">{{ '工作地址' }}</div>
            <div class="infot2">{{ setitem.workingAddress }}</div>
            <div class="infot1">{{ '所属部门' }}</div>
            <div class="infot2">{{ setitem.branch }}</div>
            <div class="infot1">{{ '人选必备项' }}</div>
            <div class="infot2">{{ setitem.personSelEssential }}</div>
            <div class="infot1">{{ '人选核心项' }}</div>
            <div class="infot2">{{ setitem.personSelCore }}</div>
            <div class="infot1">{{ '人选加分项' }}</div>
            <div class="infot2">{{ setitem.personSelBonuspoint }}</div>
            <div class="infot1">{{ '面试流程' }}</div>
            <div class="infot2">{{ setitem.interviewProcess }}</div>
            <div class="infot1">{{ '工作时间' }}</div>
            <div class="infot2">{{ setitem.workHours }}</div>
            <div class="infot1">{{ '汇报对象' }}</div>
            <div class="infot2">{{ setitem.reportObject }}</div>
            <div class="bt">公司详情</div>
            <div class="infot1">{{ '企业名称' }}</div>
            <div class="infot2">{{ setitem.customCompanyEVo.customCompanyFullName }}</div>
            <div class="infot1">{{ '公司行业' }}</div>
            <div class="infot2">{{ setitem.customCompanyEVo.industry }}</div>
            <div class="infot1">{{ '公司地址' }}</div>
            <div class="infot2">{{ setitem.customCompanyEVo.detailedAddress }}</div>
            <div class="infot1">{{ '企业网站' }}</div>
            <div class="infot2">{{ setitem.customCompanyEVo.customCompanyWeb }}</div>
            <div class="infot1">{{ '融资情况' }}</div>
            <div class="infot2">{{ setitem.customCompanyEVo.financingStage }}</div>
            <div class="infot1">{{ '人员规模' }}</div>
            <div class="infot2">{{ setitem.customCompanyEVo.staffSize }}</div>
            <div class="bt">关注该职位的顾问({{ setitem.followUserInfoVoList.length  }})</div>
            <div class="infot" v-if="setitem.followUserInfoVoList <= 0">当前暂无顾问关注该职位</div>

            <div class="avabox"> 
                <el-image class="avaters" :key="index" v-for="(item,index) in setitem.followUserInfoVoList" fit="cover" size="large" :src="item.avatarPath"></el-image>    
            </div>

            <div class="bt">职位公告<div class="btn" @click="passortg2()">添加公告</div></div>
            <div class="fkBox">
                <div class="tip" v-if="zwgg.length <= 0">当前暂无职位公告</div>
                <div class="tipbox" v-for="(item,index) in zwgg" :key="index">
                    <div class="boxbottom">
                        {{ item.notice }}
                    </div>
                    <div class="boxtop">
                        <div class="topp2 close" @click="deletegg(item.id)">删除</div>
                    </div>
                </div>
            </div>
            </div>
            <el-table v-if="!setitem" :data="postList" border style="width: 100%" :row-key="function(e){
                return e.id
            }">
                <el-table-column prop="positionName" label="职位名称" align="center" >
                </el-table-column>
                <el-table-column prop="branch" label="部门名称" align="center" >
                </el-table-column>
                <el-table-column label="猎头费" align="center">
                    <template slot-scope="scope">
                        {{(Number(scope.row.salaryMax) +  Number(scope.row.salaryMin)) * 9 / 100 + 'w'}}
                    </template>
                </el-table-column>
                <el-table-column label="信息" align="center" width="500">
                    <template slot-scope="scope">
                        {{scope.row.provinceName}}{{' '}}|{{' '}}{{scope.row.cityName}}{{' '}}|{{' '}}{{scope.row.areaName}}{{' '}}|{{' '}}
                        <span v-if="scope.row.workingLifeMin>10 && scope.row.workingLifeMax > 10">10年以上</span>
                        <span v-if="scope.row.workingLifeMin<11 && scope.row.workingLifeMax>10">{{scope.row.workingLifeMin}}年以上</span>
                        <span v-if="((scope.row.workingLifeMin !== scope.row.workingLifeMax) && scope.row.workingLifeMin < 11 && scope.row.workingLifeMax < 11)">{{scope.row.workingLifeMin}}~{{scope.row.workingLifeMax}}年</span>
                        <span v-if="((scope.row.workingLifeMin === scope.row.workingLifeMax) && scope.row.workingLifeMin < 11)">{{scope.row.workingLifeMin}}年</span>
                        {{' '}}|{{' '}}
                        {{scope.row.minYearSalary === scope.row.maxYearSalary ? scope.row.minYearSalary + 'w' : scope.row.minYearSalary + '~' + scope.row.maxYearSalary + 'w' }}
                    </template>
                </el-table-column>
                <el-table-column prop="xstime" label="发布时间" align="center">
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="200px" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small"   @click="showsj(scope.$index, 1, true)" v-if="Number(scope.row.status) === 2 || Number(scope.row.status) === 0" slot="reference">
                            上架职位
                        </el-button>
                        <el-button type="text" size="small" v-if="Number(scope.row.status) === 1" @click="shwoxj(scope.$index, 2, true)" slot="reference">
                            下架职位
                        </el-button>
                        <el-button type="text" size="small" @click="editPost(scope.row.id)" v-if="Number(scope.row.status) === 2" slot="reference">
                            编辑职位
                        </el-button>
                        <el-button type="text" size="small" @click="opQr(scope.row.id)"  slot="reference">
                            预览职位
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>

    </div>
    <el-dialog :title="form1.title" :visible.sync="dialogFormVisible1">
        <el-form :model="form1">
            <el-form-item :label="form1.par" :label-width="formLabelWidth">
            <el-input v-model="form1.notice" autocomplete="off" :placeholder="'请输入' + form1.par"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible1 = false">取 消</el-button>
            <el-button type="primary" @click="addgg() ">确 定</el-button>
        </div>
    </el-dialog>

    <el-dialog
  title="提示"
  :visible.sync="dialogVisiblesj"
  width="30%"
  :before-close="handleClose">
  <span>是否上架该职位</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisiblesj = false">取 消</el-button>
    <el-button type="primary" @click="popover(clindex,cltype,true)">确 定</el-button>
  </span>
</el-dialog>
<el-dialog
  title="提示"
  :visible.sync="dialogVisiblexj"
  width="30%"
  :before-close="handleClose">
  <span>是否下架该职位</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisiblexj = false">取 消</el-button>
    <el-button type="primary" @click="popover(clindex,cltype,true)">确 定</el-button>
  </span>
</el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import moment from 'moment'
let QRCode = require('qrcode')
export default {
    name: 'myPost',
    props: {},
    data() {
        return {
            dialogVisiblexj: false,
            dialogVisiblesj: false,
            jobname: '',
            Number:Number,
            moment: moment,
            tagstyle: [
                'success',
                'info',
                'warning',
                'danger'
            ],
            loading: false,
            postStatus: '1',
            postList: [],
            postPageNum: 1,
            postPageSize: 10,
            postPageTotle: 0,
            postPageTotle1: 0,
            postPageTotle2: 0,
            QrUrl: '',
            qrdialogVisible: false,
            setitem: false,
            zwgg: [],

            clindex: 0,
            cltype: 1,

            dialogFormVisible1: false,
            form1: {
                    title:'',
                    par: '',
                    notice: '',
                    id: ''
                   }
        }
    },
    watch: {},
    created: function () {},
    methods: {
        showsj: function (index,type,status) {
            this.clindex = index
            this.cltype = type
            this.dialogVisiblesj = true
        },
        shwoxj: function (index,type,status) {
            this.clindex = index
            this.cltype = type
            this.dialogVisiblexj = true
        },
        changePostStatus: function (e) {
            this.postStatus = e
            this.postPageNum = 1
            this.getPostList()
            this.getPostTotal1()
            this.getPostTotal2()
        },
        handleCurrentChange: function (e) {
            this.postPageNum = e
            this.getPostList()
            this.getPostTotal1()
            this.getPostTotal2()
        },
        cxjblistv: function () {
            debugger;
            this.pageNum = 1
            this.getPostList()
            this.getPostTotal1()
            this.getPostTotal2()
        },

        getPostTotal1: function () {
            let that = this
            let data = {
                pageNum: 1,
                pageSize: 1,
                status: 1
            }
            if (that.jobname !== '' && that.jobname !== 'all') {
                data.jobName = that.jobname
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobinfo/myJobList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: data,
            }).then((res) => {
                if (res.data.success === '1') {
                    that.postPageTotle1 = res.data.content.total
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        getPostTotal2: function () {
            let that = this
            let data = {
                pageNum: 1,
                pageSize: 1,
                status: 2
            }
            if (that.jobname !== '' && that.jobname !== 'all') {
                data.jobName = that.jobname
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobinfo/myJobList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: data,
            }).then((res) => {
                if (res.data.success === '1') {
                    that.postPageTotle2 = res.data.content.total
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },

        getPostList: function () {
            let that = this
            that.loading = true;
            let data = {
                pageNum: that.postPageNum,
                pageSize: that.postPageSize,
                status: Number(that.postStatus)
            }
            if (that.jobname !== '' && that.jobname !== 'all') {
                data.jobName = that.jobname
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobinfo/myJobList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: data,
            }).then((res) => {
                that.loading = false;
                if (res.data.success === '1') {
                    for (let i = 0; i < res.data.content.list.length; i++) {
                        res.data.content.list[i].visible1 = false
                        res.data.content.list[i].visible2 = false
                        res.data.content.list[i].visible3 = false
                        res.data.content.list[i].xstime = moment(res.data.content.list[i].createTime).format('YYYY-MM-DD HH:mm:ss')
                    }
                    that.postList = res.data.content.list
                    that.postPageTotle = res.data.content.total
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.loading = false;
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        popover: function (index, flag, status) {
            this.dialogVisiblexj = false
            this.dialogVisiblesj = false
            if (flag === 2 && status) {
                this.goOutline(index)
            }
            if (flag === 1 && status) {
                this.goOnlineCopy(index)
            }
        },
        goOutline: function (index) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobinfo/downJob',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobid: this.postList[index].id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.$message({
                        showClose: true,
                        message: '该职位下架成功',
                        type: 'success',
                        duration: 1500
                    });
                    that.getPostList()
                    that.getPostTotal1()
                    that.getPostTotal2()
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        goOnlineCopy: function (index) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobinfo/copyJob',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobid: this.postList[index].id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.goOnline(res.data.content.id)
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        goOnline: function (id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobinfo/upJob',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobid: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.$message({
                        showClose: true,
                        message: '该职位上架成功',
                        type: 'success',
                        duration: 1500
                    });
                    that.getPostTotal1()
                    that.getPostTotal2()
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        editPost: function (id) {
            this.$router.push({
                path: '/editPost',
                query: {
                    id: id
                }
            })
        },
        opQr: function (id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobinfo/getjobDetail',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobid: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    debugger
                    res.data.content.label = res.data.content.label === null ? '' : res.data.content.label
                    that.setitem = res.data.content
                    that.getZwGg()
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        closetsc: function () {
             
            this.setitem = false
        },
        getZwGg: function  () {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobNotice/jobNoticeList',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobId: that.setitem.id,
                    pageNum: 1,
                    pageSize: 100
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    let demoList = []
                    demoList = res.data.content.list
                    for (let item in demoList) {
                        var a = moment()
                        var b = moment(demoList[item].createTime)
                        if (a.diff(b, 'days') >= 1) {
                        if (
                            moment(demoList[item].createTime).format('YYYY') ===
                            moment().format('YYYY')
                        ) {
                            demoList[item].xsTime =
                            moment(demoList[item].createTime).format('MM月DD日 HH:mm') +
                            ' '
                        } else {
                            demoList[item].xsTime =
                            moment(demoList[item].createTime).format(
                                'YYYY年MM月DD日 HH:mm'
                            ) + ' '
                        }
                        } else if (a.diff(b, 'hours') >= 1) {
                        demoList[item].xsTime = a.diff(b, 'hours') + '小时前 '
                        } else if (a.diff(b, 'minutes') >= 1) {
                        demoList[item].xsTime = a.diff(b, 'minutes') + '分钟前 '
                        } else {
                        demoList[item].xsTime = '刚刚 '
                        }
                    }
                    that.zwgg = demoList
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        passortg1 (item)  {
            this.form1 = {
                title:'编辑公告',
                par: '职位公告',
                notice: item.notice,
                id: item.id
            }
            this.dialogFormVisible1 = true
        },
        addgg () {
            let that = this
            let id = this.setid
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobNotice/jobNoticeAdd',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    jobId: that.setitem.id,
                    notice: this.form1.notice
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.getZwGg()
                    that.dialogFormVisible1 = false
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
        passortg2 (item)  {
            this.form1 = {
                title:'添加公告',
                par: '职位公告',
                notice: '',
                id: ''
            }
            this.dialogFormVisible1 = true
        },
        deletegg (id) {
            let that = this
            axios({
                method: 'POST',
                url: Config.path + '/api/enterprise/jobNotice/jobNoticeDel',
                headers: {
                    token: localStorage.getItem('token'),
                    'content-type': 'application/json'
                },
                data: {
                    id: id
                },
            }).then((res) => {
                if (res.data.success === '1') {
                    that.getZwGg()
                } else if(res.data.success === '111111') {
                    that.$message.error(res.data.message);
                    setTimeout(()=>{
                        window.location.href = 'https://www.pinkuaikuai.cn/login.html'
                    },1000)
                }  else {
                    that.$message.error(res.data.message);
                }
            }).catch((err) => {
                that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常');
            })
        },
    },
    mounted: function () {
        this.getPostList()
        this.getPostTotal1()
        this.getPostTotal2()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myPostIndexnew {

    min-width: 100vw;
    flex: 1;
    padding-top: 1px;
    position: relative;
    background-color: #e6e6e6;
        .paginationBox {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            position: fixed;
            bottom: 100px;
            left: 50%;
            transform: translateX(-50%);
            background-color: #ffffff;
            width: max-content;
            padding: 5px 40px;
            z-index: 9999;
            border-radius: 10px;

            .el-pager {
                li {
                    background: transparent;
                    color: #5DC2D0;
                }

                .active {
                    background: #fff;
                    color: #5DC2D0;
                }
            }

            .el-pagination .btn-prev,
            .el-pagination .btn-next {
                background-color: transparent;

                i {
                    color: #ffffff;
                }
            }
        }

    .cont {
        width: 100vw;
        overflow-x: scroll;
        height: calc(100%);
        border-radius: 8px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        overflow: visible;

        .selectCont {
            width: 311px;
            background-color: #ffffff;
            box-sizing: border-box;
            margin-top: 30px;
            padding: 35px 22px;
            border-radius: 10px;
            margin-left: 20px;

            .jobname{
                width: 250px;
                margin: 0 auto 50px auto;
            }

            .el-radio-group {
                // margin-left: 40px;

                .el-radio-button__inner {
                    background-color: transparent;
                    color: #5DC2D0;
                }

                .is-active {
                    .el-radio-button__inner {
                        background-color: #5DC2D0;
                        color: #ffffff;
                        border-color: #ffffff;
                    }
                }
            }
        }

        .tableCont {
            flex: 0.9;
            margin-top: 30px;
            box-sizing: border-box;
            background-color: #ffffff;
            margin-right: 20px;
            border-radius: 10px;
            padding: 30px;
            position: relative;
            overflow-x: scroll;


            .zwinfobox{
                position: relative;
                top: 0;
                left: 0;
                width: 95%;
                box-sizing: border-box;
                background-color: #ffffff;
                margin-right: 20px;
                border-radius: 10px;
                padding: 30px;
                height: calc(100vh - 200px);
                z-index: 10;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                overflow-y: scroll;
                height: fit-content;

                .qyname{
                    font-size: 18px;
                    color: #a3a3a3;
                    font-weight: bold;
                    margin-bottom: 10px;
                }

                
                .zwname{
                    font-size: 40px;
                    font-weight: bold;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-start;

                    .el-tag{
                        margin-left: 10px;
                    }
                }



                .jcinfo{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-start;
                    margin-top: 10px;
                    color: #a3a3a3;

                    span{
                        i{
                            margin-right: 5px;
                        }
                        margin-right: 20px;
                    }
                }

                
                .jcinfo1{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: flex-start;
                    margin-top: 10px;
                    color: #606060;

                    div{
                        span{
                            margin-right: 5px;
                        }
                        margin-right: 20px;
                    }
                }

                .infot{
                    color: #606060;
                }
                .infot1{
                    font-size: 16px;
                    color: #606060;
                    border-bottom: 2px solid #606060;
                }

                .infot2{
                    margin-top: 10px;
                    margin-bottom: 10px;
                    font-size: 14px;
                    color: #606060;
                }
                
                .avabox{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;

                    .avaters{
                        width: 75px;
                        height: 75px;
                        border-radius: 100%;
                        margin-right: 15px;
                    }

                }




                .topbtnbox{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    width: 90%;
                    margin-bottom: 30px;

                    .delbtn{
                        color: #000000;
                        margin-right: 20px;
                        width: 100px;
                        height: 40px;
                        line-height: 40px;
                        border-radius: 5px;
                        text-align: center;
                        cursor: pointer;

                        i{
                            color: #000000;
                            margin-right: 5px;
                        }
                    }
                }


                .bt{
                    width: 90%;
                    font-size: 20px;
                    font-weight: bold;
                    padding-left: 20px;
                    height: 26px;
                    line-height: 26px;
                    border-left: 5px solid #5dc1cf;
                    margin-bottom: 30px;
                    margin-top: 30px;
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    .btn{
                        cursor: pointer;
                        width: 120px;
                        height: 36px;
                        font-size: 18px;
                        line-height: 36px;
                        border-radius: 36px;
                        background-color: #5dc1cf;
                        color: #ffffff;
                        text-align: center;
                    }
                }

                .fkBox{
                    width: 90%;
                    padding: 30px;
                    box-sizing: border-box;
                    border-radius: 10px;
                    background-color: #c0ac584d;
                    margin: 30px auto;



                    .title{
                        color: #4d4d4d;
                        font-weight: bold;
                        margin-bottom: 10px;
                    }
                    .tip{
                        color: #4d4d4d;
                    }
    
                    .tipbox{
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        align-items: flex-start;
                        margin: 0px 0 30px 0;
                        .boxtop{
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: flex-start;
                            width: 100%;
                            .topp1{
                                color: #4d4d4d;
                                font-size: 18px;
                                font-weight: bold;
                                margin-right: 20px;
                                cursor: pointer;
                            }
                            .topp2{
                                color: #4d4d4d;
                                font-size: 18px;
                                font-weight: bold;
                                cursor: pointer;
                            }
                            .close{
                                color: red;
                            }
                            .pass{
                                color: green;
                            }
                        }
                        .boxbottom{
                            margin-bottom: 20px;
                            color: #4d4d4d;
                        }
                    }
                }

            }

            // * {
            //     background-color: transparent;
            //     color: #5DC2D0;
            // }

            .el-table--group,
            .el-table--border {
                border: none;

                &:after {
                    border: none;
                }
            }

            .el-table--group,
            .el-table--border {
                border: none;
            }

            .el-table--border th,
            .el-table--border td {
                border: none;
            }

            .el-table--group::after,
            .el-table--border::after,
            .el-table::before {
                height: 0;
                width: 0;
            }

            .el-table__header-wrapper {
                border-bottom: 1px solid #5DC2D0;
            }

            .el-table__body tr {
                >td {
                    span {
                        margin: 0 5px;
                    }
                }

                &:hover {
                    >td {
                        background-color: #5DC2D0;

                        div {
                            color: #ffffff;
                        }

                        span {
                            color: #ffffff;
                            margin: 0 5px;
                        }
                    }
                }
            }
        }


    }
}
</style>
